import documentEditor from 'serviceWorker/services/documents/editDocument';
import { SyncStatus } from 'shared/domain/entitySyncStatus/syncStatus';

export type SetDocumentSync = (localId: number, syncStatus: SyncStatus) => Promise<number>;

/** Stores the sync status and broadcasts the document update. */
export const setDocumentSync: SetDocumentSync = async function _setDocumentSync(
  localId: number,
  syncStatus: SyncStatus
): Promise<number> {
  await documentEditor.execute(localId, { localId, syncStatus });
  return localId;
};
